import React from 'react';
import cn from 'classnames';

export const Image = ({
  className,
  src,
  loading = 'lazy',
  onClick = null,
  aspectRatio = null,
  alt = '',
  imageWrapper = true,
}) => {
  const clickHandler = () => {
    if (onClick) {
      onClick();
    }
  };

  const imageClass = cn({
    [className]: true,
    image: imageWrapper,
  });

  return (
    <>
      {imageWrapper ? (
        <div
          className="image-wrapper"
          onClick={clickHandler}
          style={{ aspectRatio }}
        >
          <img className={imageClass} loading={loading} src={src} alt={alt} />
        </div>
      ) : (
        <img className={imageClass} loading={loading} src={src} alt={alt} />
      )}
    </>
  );
};
